export const refs = {
  filmsContainerRef: document.querySelector('.films-container'),
  headerButtons: document.querySelector('.header-functional'),
  pageLibrary: document.querySelector('.page-library'),
  headerFunctional: document.querySelector('.header-functional'),
  pageHome: document.querySelector('.page-home'),
  plug: document.querySelector('.plug-message'),
  header: document.querySelector('.header'),
  filterBox: document.querySelector('.genres-menu--box'),
  filterBtn: document.querySelector('.genres-filter-btn'),
  filterChooseAll: document.querySelector('.genres-menu--all'),
  filterHiddenContainer: document.querySelector('.filter-hidden-container'),
  genresBtn: document.querySelector('.genres-menu--container'),
  openTeamBtn: document.querySelector('[team-modal-open]'),
  closeTeamBtn: document.querySelector('[team-modal-close]'),
  team: document.querySelector('[team-modal]'),
};
